import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export type MessageBoxTheme = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-message-box',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './message-box.component.html',
  styleUrl: './message-box.component.scss'
})
export class MessageBoxComponent {
  @Input() theme: MessageBoxTheme = 'info';
  @Input() icon!: string;
  @Input() title!: string;
  @Input() allowHtml: boolean = false;

  constructor() {}

  get themeClass(): string {
    return `message-box-${this.theme}`;
  }
}
